import { memo } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { ISubtitles } from 'src/interfaces/PlayerData';
import { CheckIcon } from 'src/themes/cosmos/icons';
import SettingOption from '../SettingOption';

export interface ISubtileControlProps {
  subtitles: ISubtitles[] | null;
  activeSubtitle: ISubtitles | null;
  onChange: (subtitle: ISubtitles) => void;
  onDisable: () => void;
}

const SubtitleControl = ({ subtitles, activeSubtitle, onChange, onDisable }: ISubtileControlProps) => {
  const { t } = useTranslation('common');
  return (
    <>
      <SettingOption
        aria-label='subtitle option disabled'
        active={!activeSubtitle}
        rightIcon={!activeSubtitle && <CheckIcon />}
        onClick={onDisable}
      >
        {t('toggle.disable')}
      </SettingOption>
      {subtitles?.map((subtitle) => {
        const isActive = subtitle.language === activeSubtitle?.language;
        return (
          <SettingOption
            key={subtitle.label}
            aria-label={`subtitle option ${subtitle.label}`}
            active={isActive}
            rightIcon={isActive && <CheckIcon />}
            onClick={() => onChange(subtitle)}
          >
            {subtitle.label}
          </SettingOption>
        );
      })}
    </>
  );
};

export default memo(SubtitleControl);
